import { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Alert, Box, Button, Checkbox, Divider, FormControlLabel, Grid, Radio, selectClasses, Switch, TextField, Tooltip, Typography, useTheme } from "@mui/material";
import { SendEmailInfo, newSendEmailInfo, EmailProvider, newEmailSetting, EmailSetting, newEmailProvider } from "../Email";
import {User} from "../../model"
import { SingleSelectSearch } from "../../components/ui/DropdownSelect";


interface SendEmailFormProps {
  item: SendEmailInfo;
  error?: string;

  user?: User;
  EmailSettingList?: EmailSetting[];
}

export interface SendEmailInfoFormRef {
  valid: () => boolean;
  getItem: () => SendEmailInfo;
}

export const SendEmailForm = forwardRef((props: SendEmailFormProps, ref) => {
  const { error, user, EmailSettingList } = props;
  const [item, setItem] = useState<SendEmailInfo>(newSendEmailInfo());
  const [submitted, setSubmitted] = useState(false);
  const [userdata, setuserdata] = useState<User>();
  const [settingList, setSettingList] = useState<EmailSetting[]>([]);

  useEffect(() => {
    setItem(props.item);
  }, [props.item]);

  useEffect(() => {
    if (user.emailaddress != null){
        item.recipient_email = "dette er en test"
    }
  }, [props.user])

  const [touched, setTouched] = useState<{
    base: Record<string, boolean>;
  }>({
    base: {},
  });

  const valid = () => {
    let hasErrors = false;

    // Validate all base fields
    for (const key of Object.keys(item) as (keyof SendEmailInfo)[]) {
      if (typeof item[key] !== "object" && validateBaseField(key)) {
        hasErrors = true;
      }
    }

    setSubmitted(true);
    return !hasErrors;
  }

  useEffect(() => {
    if (EmailSettingList) {
      setSettingList(EmailSettingList);
    }
  }, [EmailSettingList]);
  
//   useEffect(() => {
//     if (EmailProviderList) {
//       setProviderList(EmailProviderList);
//     }
//   }, [EmailProviderList]);

//   useEffect(() => {
//     if (user) {
//       item.recipient_email = "dette er en test"
//     }
//   }, [user]);

  const getItem = () => {
    return item;
  }

  // Expose the valid function to the parent, and a method to get the whole item object
  useImperativeHandle(ref, () => ({
    valid,
    getItem,
  }));

  const validateBaseField = (field: keyof SendEmailInfo): string => {
    if (field === "email_subject") {
      if (!item.email_subject?.trim()) return "Tittel kan ikke være tomt";
    }if (field === "recipient_email") {
        if (!item.recipient_email?.trim()) return "Mottaker kan ikke være tomt";
      }
    return ""; // No error
  };

  const handleBaseChange = (field: keyof SendEmailInfo, value: any) => {
    setItem((prev) => ({ ...prev, [field]: value }));
  };

  const handleBaseBlur = (field: keyof SendEmailInfo) => {
    setTouched((prev) => ({
      ...prev,
      base: { ...prev.base, [field]: true },
    }));
  };

  return (
    <form>
      <Grid container spacing={2}
        sx={{ justifyContent: 'center', alignItems: 'center' }}
      >
        {error && <Alert sx={{ width: '100%' }} severity="error">{error}</Alert>}
        <Grid item xs={12}>
          <TextField
            label="Mottaker"
            required
            fullWidth
            value={item.recipient_email}
            onChange={(e) => handleBaseChange("recipient_email", e.target.value)}
            variant="outlined"
            error={validateBaseField("recipient_email") !== "" && (submitted || touched.base.recipient_email)}
            helperText={(submitted || touched.base.recipient_email) ? validateBaseField("recipient_email") : ""}
            onBlur={() => handleBaseBlur("recipient_email")}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Tittel"
            fullWidth
            value={item.email_subject}
            onChange={(e) => handleBaseChange("email_subject", e.target.value)}
            variant="outlined"
            error={validateBaseField("email_subject") !== "" && (submitted || touched.base.email_subject)}
            helperText={(submitted || touched.base.email_subject) ? validateBaseField("email_subject") : ""}
            onBlur={() => handleBaseBlur("email_subject")}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Tekst"
            fullWidth
            value={item.email_body}
            onChange={(e) => handleBaseChange("email_body", e.target.value)}
            variant="outlined"
            error={validateBaseField("email_body") !== "" && (submitted || touched.base.email_body)}
            helperText={(submitted || touched.base.email_body) ? validateBaseField("email_body") : ""}
            onBlur={() => handleBaseBlur("email_body")}
          />
        </Grid>
        <Grid item xs={6} md={4}>
            <SingleSelectSearch
              label="smtp instilling"
              inputs={settingList}
              selectField="name"
              selected={item.email_setting_id ?? null}
              onChange={(id) => {
                handleBaseChange("email_setting_id", id)
                setItem((prev) => ({
                  ...prev,
                  email_setting_id: id,
                }));
              }}
              onBlur={() => handleBaseBlur("email_setting_id")}
            />
        </Grid>
      </Grid>
    </form>
  )
});